import React, { useCallback } from 'react';
import { FormControl } from 'react-bootstrap';
import compose from 'ramda/src/compose';
import path from 'ramda/src/path';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const SearchColumnFilter = ({ column: { filterValue, setFilter, Header, id, onFilterChange } }) => {
    const handleFilterChange = useCallback(
        (event) => {
            const value = compose(path(['target', 'value']))(event);
            const trimmedValue = value || '';
            setFilter(trimmedValue || undefined);

            if (onFilterChange) {
                onFilterChange(id, trimmedValue);
            }
        },
        [id, onFilterChange, setFilter]
    );

    return (
        <FormControl
            type="text"
            value={filterValue || ''}
            onChange={handleFilterChange}
            size="sm"
            placeholder={`Filter by ${Header}`}
            className="input-filter"
            aria-label={`Filter by ${Header}`}
        />
    );
};

export default SearchColumnFilter;
